import { PHASE_COLORS_HEX } from "./GrowPhaseBar.jsx";

export const EVENT_META = {
  misted:           { icon: "💧", short: "Mist",   label: "Misted",        color: "#3b82f6" },
  fan_adjusted:     { icon: "🌀", short: "Fan",    label: "Fan adjusted",  color: "#8b5cf6" },
  harvested:        { icon: "🧺", short: "Harv",   label: "Harvested",     color: "#10b981" },
  contam_spotted:   { icon: "⚠️", short: "Cont",   label: "Contamination", color: "#ef4444" },
  phase_transition: { icon: "🔄", short: "Phase",  label: "Phase",         color: "#f59e0b" },
  photo_taken:      { icon: "📷", short: "Photo",  label: "Photo",         color: "#6b7280" },
  custom:           { icon: "📌", short: "Event",  label: "Custom",        color: "#9ca3af" },
};

// Returns the set of event_type strings that appear in notes (for chip rendering).
export function activeEventTypes(notes = []) {
  const seen = new Set();
  for (const n of notes) {
    if (n.event_type && EVENT_META[n.event_type]) seen.add(n.event_type);
  }
  return [...seen];
}

// Computes the `marks` prop for MetricChart.
// enabledTypes: Set of event_type strings to show (null = show all).
export function computeGrowMarks(phases = [], notes = [], enabledTypes = null) {
  const now = Date.now();

  // Phase background bands
  const markArea = {
    silent: true,
    data: phases.map((phase) => [
      {
        name: phase.phase_name,
        xAxis: new Date(phase.started_at).getTime(),
        itemStyle: {
          color: PHASE_COLORS_HEX[phase.phase_name] ?? "#6b7280",
          opacity: 0.10,
        },
        label: {
          show: true,
          position: "insideTopLeft",
          fontSize: 10,
          color: "#9ca3af",
          formatter: phase.phase_name,
        },
      },
      { xAxis: phase.ended_at ? new Date(phase.ended_at).getTime() : now },
    ]),
  };

  // Phase boundary lines (dashed gray, no label)
  const phaseBoundaryLines = phases
    .filter((p) => p.ended_at)
    .map((p) => ({
      xAxis: new Date(p.ended_at).getTime(),
      lineStyle: { type: "dashed", color: "#6b7280", width: 1 },
      label: { show: false },
    }));

  // Event lines — vertical solid lines with icon label at top
  const typedNotes = notes.filter((n) => {
    if (!n.event_type || !EVENT_META[n.event_type]) return false;
    if (enabledTypes && !enabledTypes.has(n.event_type)) return false;
    return true;
  });

  const eventLines = typedNotes.map((n) => {
    const meta = EVENT_META[n.event_type];
    return {
      xAxis: new Date(n.created_at).getTime(),
      lineStyle: { type: "solid", color: meta.color, width: 1.5, opacity: 0.8 },
      label: {
        show: true,
        position: "start",
        distance: 4,
        formatter: meta.short,
        fontSize: 10,
        fontWeight: "bold",
        color: "#fff",
        backgroundColor: meta.color,
        borderRadius: 3,
        padding: [2, 4, 2, 4],
      },
    };
  });

  const markLine = {
    silent: true,
    symbol: "none",
    data: [...phaseBoundaryLines, ...eventLines],
  };

  return { markArea, markLine };
}
